import React, { Component, useEffect } from 'react';
import evio from '../../styles/images/evio.svg';
import Hyundai from '../../styles/images/brands/hyundai.svg';
import ACP from '../../styles/images/brands/acp.svg';
import error from "../../styles/images/error.svg";
import '../../styles/components/notifications/Notifications.css'
import '../../styles/components/notifications/Checkbox.scss'
import { connect } from "react-redux";
import axios from "axios";
import { setLanguage } from "../../actions/languageActions";
import { Translate } from "react-redux-i18n";
import { Link } from "react-router-dom";
import evio_o_black from "../../styles/images/evio_o_black.svg";

class Notifications extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            reasons: {
                licenseServices: false,
                licenseProducts: false,
                licenseMarketing: false,
                all_communication: false
            },
            reasonsInitialStates: {
                licenseServices: false,
                licenseProducts: false,
                licenseMarketing: false,
                all_communication: false
            },
            showRequestResult: false,
            requestResult: false,
            clientName: 'Evio',
            email: 'example@example.com',
            hash: '',
            language: 'en',
            loading: true,
            tryAgain: false,
        };
        this.submitData = this.submitData.bind(this);
        this.swapAPIkey = this.swapAPIkey.bind(this);
    }

    componentDidMount() {
        const currentUrl = window.location.pathname;
        const pathSegments = currentUrl.split('/');
        const hash = pathSegments[pathSegments.length - 1]
        this.setState({
            hash: hash,
        });
        this.getData(hash);
    };

    getData(hash){
        axios
        .get(`/evioapi/users/unsubscribe/marketing/${hash}`)
        .then(res => {
            this.setState({
                loading: false,
                email: res.data.email,
                clientName: res.data.clientName,
                reasons: {
                    licenseServices: res.data.licensePreferences.licenseServices,
                    licenseProducts: res.data.licensePreferences.licenseProducts,
                    licenseMarketing: res.data.licensePreferences.licenseMarketing,
                },
                reasonsInitialStates: {
                    licenseServices: res.data.licensePreferences.licenseServices,
                    licenseProducts: res.data.licensePreferences.licenseProducts,
                    licenseMarketing: res.data.licensePreferences.licenseMarketing,
                },
                language: res.data.language,
                showRequestResult: false,
            });

            // Logic to dinamicaly modify the favIcon depending on the whitelabel
            var link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.head.appendChild(link);
            }

            if(this.state.clientName === "Hyundai"){
                link.href = Hyundai;
            } 

            if(this.state.clientName === "ACP"){
                link.href = ACP;
            }

            if(this.state.clientName === "EVIO"){
                link.href = evio;
            }

            this.props.setLanguage(res.data.language)
            axios.defaults.headers['apikey'] = this.swapAPIkey(res.data.clientName);
        }).catch(() => {
            this.setState({tryAgain: true})
        })
    }

    swapAPIkey(brand){
        if (brand == 'ACP') { return process.env.REACT_APP_ACP}
        if (brand == 'Hyundai') { return process.env.REACT_APP_HYUNDAI}
        if (brand == 'EVIO') { return process.env.REACT_APP_EVIOAPI}
    }

    submitData(){
        this.setState({
            loading: true
        });

        const hash = this.state.hash;
        const reasons = this.state.reasons
        axios
        .patch(`/evioapi/users/unsubscribe/marketing/${hash}`, {
                licensePreferences: {
                    licenseServices: reasons.licenseServices,
                    licenseProducts: reasons.licenseProducts,
                    licenseMarketing: reasons.licenseMarketing,
                },
        })
        .then(res => {
            this.setState({
                requestResult: true,
                showRequestResult: true,
            });
        })
        .catch(err => {
            this.setState({
                requestResult: false,
                showRequestResult: true,
            });
        }).finally( res => {
                this.setState({
                    loading: false
                });
            }
        )
    }

    handleToggleAll = (reason) => {
        this.setState((prevState) => ({
            reasons: {
                ...prevState.reasons,
                licenseServices: !prevState.reasons[reason] ? false : prevState.reasonsInitialStates['licenseServices'],
                licenseProducts: !prevState.reasons[reason] ? false : prevState.reasonsInitialStates['licenseProducts'],
                licenseMarketing: !prevState.reasons[reason] ? false : prevState.reasonsInitialStates['licenseMarketing'],
                all_communication: !prevState.reasons[reason],
            }
        }))
    };

    handleToggleTrue = (reason) => {
        this.setState((prevState) => ({
            reasons: {
            ...prevState.reasons,
            [reason]: true,
            all_communication: false
            }
        }));
    };

    handleToggleFalse = (reason) => {
        this.setState((prevState) => ({
            reasons: {
            ...prevState.reasons,
            [reason]: false,
            }
        }));
    };

    selectImage() {
        const clientName = this.state.clientName;
        if(clientName == "Hyundai") {
            return Hyundai
        } else {
            if (clientName == "ACP") {
                return ACP
            } else {
                return evio
            }
        }
    }

    render() {
    const { reasons } = this.state;
    return (
        <div className="notifications-container">
        {!this.state.showRequestResult ? 
            (<div className="notifications-wrapper">
                {this.state.loading ? 
                    <div className='loaderDiv'>
                        {this.state.tryAgain ?
                            <div id="notFound">
                            <img src={evio_o_black} alt="" />
                            <div className="text-container" onClick={() => {this.getData(this.state.hash)}}>
                            <   Translate value="notFound_error404" />
                            </div>
                        </div>
                        : 
                        <div class="loader"></div>
                        }
                        
                    </div>
                    :
                    <div>
                        <div>
                            <div className='centerAlignment'>
                                <img src={this.selectImage()} alt={this.state.clientName} className="evio-img" />
                            </div>
                            <h2><b><Translate value="headerText1"  /></b></h2>
                            <h6>
                                <Translate value="headerText2"  />{this.state.email}<Translate value="headerText3"  />{this.state.clientName}<Translate value="headerText4"  />
                            </h6>
                            <div className="preferences-text">
                            <h5><b><Translate value="preferencesText1"  /></b></h5>
                            <h7>
                                <Translate value="preferencesText2"  />
                            </h7>
                            </div>
                        </div>

                        <form className="preferences-form">
                        <div className='yesNoHeader' >
                                <div><b><Translate value="yes"  /></b></div>
                                <div className='ml2r'><b><Translate value="no"  /></b></div>
                            </div>
                        {this.state.reasons.licenseServices !== undefined &&
                            <div className="preference-item">
                                
                                <div className="ml1r"><span><Translate value="preferenceOption1"  /></span></div>
                                <div className='mw1' >
                                    <input 
                                        type="checkbox" 
                                        checked={reasons.licenseServices} 
                                        onChange={() => this.handleToggleTrue('licenseServices')} 
                                    />
                                    <input 
                                        className={this.state.language === 'pt' ? 'ml3r' : 'ml2r'}
                                        type="checkbox" 
                                        checked={!reasons.licenseServices} 
                                        onChange={() => this.handleToggleFalse('licenseServices')} 
                                    />
                                </div>
                            </div>
                        }

                        {this.state.reasons.licenseProducts !== undefined && 
                            <div className="preference-item">
                                
                                <div className="ml1r"><span><Translate value="preferenceOption2"  /></span></div>
                                <div className='mw1'>
                                    <input 
                                        type="checkbox" 
                                        checked={reasons.licenseProducts} 
                                        onChange={() => this.handleToggleTrue('licenseProducts')} 
                                    />
                                    <input
                                        className={this.state.language === 'pt' ? 'ml3r' : 'ml2r'}
                                        type="checkbox" 
                                        checked={!reasons.licenseProducts} 
                                        onChange={() => this.handleToggleFalse('licenseProducts')} 
                                    />
                                </div>
                            </div>
                        }

                        {this.state.reasons.licenseMarketing !== undefined && 
                            <div className="preference-item">
                                <div className="ml1r"><span><Translate value="preferenceOption3"  /></span></div>
                                <div className='mw1'>
                                    <input 
                                    type="checkbox" 
                                    checked={reasons.licenseMarketing} 
                                    onChange={() => this.handleToggleTrue('licenseMarketing')} 
                                    />
                                    <input 
                                    className={this.state.language === 'pt' ? 'ml3r' : 'ml2r'}
                                    type="checkbox" 
                                    checked={!reasons.licenseMarketing} 
                                    onChange={() => this.handleToggleFalse('licenseMarketing')} 
                                    />
                                </div>
                            </div>
                        }

                        <hr className="divider" />
                        <div className="preference-item spacebetween">
                            <div className="ml1r">
                                <span className='minWidth5r'><Translate value="preferenceOption4"/></span><br></br>
                                <span className='minWidth5r'><b><Translate value="preferenceOption5"/></b></span>
                            </div>
                            <div className='alignBaseline'>
                                <input 
                                type="checkbox" 
                                checked={reasons.all_communication} 
                                onChange={() => this.handleToggleAll('all_communication')} 
                                />
                            </div>
                        </div>
                        

                        </form>

                        <div>
                            <div className="buttonAlignment">
                                <button type="submit"
                                className="update-button"
                                onClick={() => {
                                    this.setState({showRequestResult: true});
                                    this.submitData();
                                    }}>
                                <Translate value="updateMyPreferences"/></button>
                            </div>
                        </div>
                    </div>
                }
            </div>)
        :
            <div className="notifications-wrapper updateResultWrapper">
                {this.state.loading ? 
                    <div className='loaderDiv'>
                        {this.state.tryAgain ?
                            <div id="notFound">
                            <img src={evio_o_black} alt="" />
                            <div className="text-container" onClick={() => {this.getData(this.state.hash)}}>
                            <   Translate value="notFound_error404" />
                            </div>
                        </div>
                        : 
                        <div class="loader"></div>
                        }
                    </div>
                    :
                    <div>
                        <div>
                            <div className='centerAlignment'>
                                <img src={this.selectImage()} alt={this.state.clientName} className="evio-img" />
                            </div>
                            <div className='resultsLayout'>
                            <h2 className='pt3rem'><b>
                                {this.state.requestResult ? <Translate value="preferencesUpdated"  /> : <Translate value="preferencesNotUpdated" />} 
                                </b>
                            </h2>
                            <img src={error} alt="" />
                            </div>
                            <h6>
                            {this.state.requestResult ? <Translate value="preferencesUpdated2" /> : <Translate value="preferencesNotUpdated2" />}
                            </h6>
                        </div>
                        <div>
                            {!this.state.requestResult && <div className="buttonAlignment">
                                <button 
                                    className="update-button"
                                    onClick={() => {
                                        this.setState({showRequestResult: false});
                                    }}>
                                <Translate value="retry"/></button>
                            </div>}
                        </div>
                </div>
            }
            </div>
        }
        </div>
    );
    }
}

const mapStateToProps = state => ({
    locale: state.i18n.locale,
});

export default connect(mapStateToProps, {
    setLanguage,
})(Notifications) ;
